export default "__VITE_ASSET__5ff8dc92__"